module.exports = __webpack_public_path__ + "img/Qstars.3f9c5b3b.jpg";